import React, { useState } from "react";
import { ManageBranchService } from "../api/services";
import { useNavigate } from "react-router-dom";
import { PiNumpadFill } from "react-icons/pi";

const SearchCardsandDevices = () => {
  const navigate = useNavigate();
  const [deviceNumber, setDeviceNumber] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [searchData, setSearchData] = useState(null);
  const [searchType, setSearchType] = useState(null); // 'device' or 'card'
  const [IsLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    // Validate input
    if (!cardNumber.trim() && !deviceNumber.trim()) {
      alert("Please enter a Device Number or Card Number");
      return;
    }

    // if (deviceNumber.trim() && cardNumber.trim()) {
    //   alert("Please search by either Device Number or Card Number, not both");
    //   return;
    // }

    if (deviceNumber.trim()) {
      await searchByDevice();
    } else {
      await searchByCard();
    }
  };

  const searchByDevice = async () => {
    const payload = { device_name: deviceNumber.trim() };
    setIsLoading(true);
    
    try {
      const res = await ManageBranchService.GetbyDeviceCode(payload);
      
      if (res.data.code === 201) {
        setSearchData(null);
        setSearchType(null);
        alert(res.data.error_message || "No Data Found");
      } else if (res.data.code === 200) {
        setSearchData(res.data.results || null);
        setSearchType("device");
      }
    } catch (err) {
      console.error("Failed to fetch device data:", err);
      setSearchData(null);
      setSearchType(null);
      alert("An error occurred while searching for the device");
    } finally {
      setIsLoading(false);
    }
  };

  const searchByCard = async () => {
    const payload = { card_name: cardNumber.trim() };
    setIsLoading(true);
    
    try {
      const res = await ManageBranchService.GetbyCardName(payload);
      
      if (res.data.code === 201) {
        setSearchData(null);
        setSearchType(null);
        alert(res.data.error_message || "No Data Found");
      } else if (res.data.code === 200) {
        setSearchData(res.data.results || null);
        setSearchType("card");
      }
    } catch (err) {
      console.error("Failed to fetch card data:", err);
      setSearchData(null);
      setSearchType(null);
      alert("An error occurred while searching for the card");
    } finally {
      setIsLoading(false);
    }
  };

  const headerStyle = {
    width: "100%",
    background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
    color: "white",
    textAlign: "left",
    padding: "20px 25px",
    fontSize: "20px",
    fontWeight: "bold",
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#fff",
    fontFamily: "Segoe UI, sans-serif",
  };

  const cardStyle = {
    backgroundColor: "white",
    width: "420px",
    marginTop: "20px",
    padding: "20px 25px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  const tableRow = (label, value) => (
    <div
      style={{
        display: "flex",
        padding: "8px 0",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <span style={{ fontWeight: "500", minWidth: "140px" }}>{label}</span>
      <span style={{ fontWeight: "500" }}>:</span>
      <span style={{ marginLeft: "10px", color: "#555" }}>
        {value || "-"}
      </span>
    </div>
  );

  return (
    <div style={containerStyle}>
      {/* Loader */}
      <div className="loader" style={IsLoading ? {} : { display: "none" }}>
        <div className="lds-spinner">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i}></div>
          ))}
        </div>
      </div>

      {/* Header */}
      <div style={headerStyle}>
        <span
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer", fontWeight: "500" }}
        >
          ← Back
        </span>
        <div className="text-center" style={{ marginTop: "10px" }}>Search Devices</div>
      </div>

      {/* Input Form */}
      <div style={cardStyle}>
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
            Device Number
          </label>
          <input
            type="text"
            value={deviceNumber}
            onChange={(e) => setDeviceNumber(e.target.value)}
            // disabled={cardNumber.trim().length > 0}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "15px",
              opacity: cardNumber.trim().length > 0 ? 0.5 : 1,
            }}
          />
        </div>

        <div
          style={{
            textAlign: "center",
            margin: "15px 0",
            color: "#999",
            fontWeight: "500",
          }}
        >
          OR
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
            Card Number
          </label>
          <input
            type="text"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            // disabled={deviceNumber.trim().length > 0}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "15px",
              opacity: deviceNumber.trim().length > 0 ? 0.5 : 1,
            }}
          />
        </div>

        <button
          onClick={handleSearch}
          disabled={IsLoading}
          style={{
            width: "100%",
            padding: "12px",
            background: "linear-gradient(to right, #ff7e5f, #feb47b)",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: IsLoading ? "not-allowed" : "pointer",
            opacity: IsLoading ? 0.7 : 1,
          }}
        >
          Search
        </button>
      </div>

      {/* Device Info - Only for Device Search */}
      {searchType === "device" && searchData && (
        <div style={cardStyle}>
          <h3 style={{ marginTop: 0, color: "#ff7e5f" }}>Device Info</h3>
          {tableRow("Device Name", searchData.device_name)}
          {tableRow("Device Code", searchData.device_no)}
          {tableRow("Mobile", searchData.mobile_no)}
          {tableRow("Type", searchData.device_type)}
          {tableRow("Admin", searchData.admin_name)}
          {tableRow("Organization", searchData.organization_name)}
          {tableRow("Branch", searchData.branch_name)}
          {tableRow("Registered On", searchData.created_date)}
          {tableRow(
            "Deleted Device",
            searchData.is_deleted === "N" ? (
              <span style={{ color: "green" }}>No</span>
            ) : (
              <span style={{ color: "red" }}>Yes</span>
            )
          )}
          {tableRow("Last Contact", searchData.last_contact)}
        </div>
      )}

      {/* Card Info - Only for Card Search */}
      {searchType === "card" && searchData && (
        <>
          <div style={cardStyle}>
            <h3 style={{ marginTop: 0, color: "#ff7e5f" }}>Card Info</h3>
            {tableRow("Card Name", searchData.card_name)}
            {tableRow("Card Code", searchData.card_no)}
            {tableRow("Admin", searchData.admin_name)}
            {tableRow("Organization", searchData.organization_name)}
            {tableRow("Branch", searchData.area_name)}
            {tableRow("Registered On", searchData.created_date)}
            {tableRow(
              "Deleted Card",
              searchData.isDeleted ? (
                <span style={{ color: "red" }}>Yes</span>
              ) : (
                <span style={{ color: "green" }}>No</span>
              )
            )}
            {tableRow("Last Used", searchData.last_used)}
          </div>

          <div style={cardStyle}>
            <h3 style={{ marginTop: 0, color: "#ff7e5f" }}>Student Info</h3>
            {tableRow("Student Name", searchData.student_name)}
            {tableRow("Parent Name", searchData.parent_name)}
            {tableRow("Relation", searchData.parent_relation)}
            {tableRow("Mobile 1", searchData.mobile_1)}
            {tableRow("Mobile 2", searchData.mobile_2)}
            {tableRow("Mobile 3", searchData.mobile_3)}
            {tableRow("Mobile 4", searchData.mobile_4)}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchCardsandDevices;

